import { useTranslation } from 'react-i18next';
import { Tabs } from '@anytag/shared-atoms';
import { useReportPermissions } from '@anytag/auth';
import { TikTokSpecialCampaignDetail } from '@anytag/graphql';
import { getAccessTikTokCampaignTab } from './utils';

interface TikTokCampaignTabsProps {
  tiktokSpecialCampaign: TikTokSpecialCampaignDetail;
}

export const TikTokCampaignTabs = ({ tiktokSpecialCampaign }: TikTokCampaignTabsProps) => {
  const { t } = useTranslation();
  const { hideReportLink } = useReportPermissions();

  const campaignId = String(tiktokSpecialCampaign?.id || '');

  return (
    <Tabs
      hasIndex
      className="campaign-tabs"
      options={[
        {
          end: true,
          label: t('Campaign Information'),
          to: '/tiktok/campaigns/$id',
          params: { id: campaignId }
        },
        {
          end: false,
          label: t('Available Influencers'),
          to: '/tiktok/campaigns/$id/influencers',
          search: { filter: { packageId: tiktokSpecialCampaign.priceItem.packageId?.toString() || '' } }
        },
        {
          end: false,
          label: t('General.Posts'),
          hidden: !getAccessTikTokCampaignTab('Posts', tiktokSpecialCampaign?.status),
          to: '/tiktok/campaigns/$id/posts',
          params: { id: campaignId }
        },
        {
          end: true,
          label: t('General.Report'),
          to: '/tiktok/campaigns/$id/report',
          params: { id: campaignId },
          hidden: !getAccessTikTokCampaignTab('Report', tiktokSpecialCampaign?.status) || hideReportLink
        }
      ]}
    />
  );
};
